import { jsx as l } from "react/jsx-runtime";
import { useChatbotContext as g } from "../../hooks/useChatbotContext.js";
function p({
  children: r,
  button: t,
  message: i,
  label: n
}) {
  const { handleAction: o, handleLinkClick: e, isEditing: a, isLoading: s } = g();
  return n || (n = `${t.buttonText} button`), /* @__PURE__ */ l(
    "button",
    {
      disabled: a || s,
      type: "button",
      "aria-label": n,
      className: "flex flex-row items-center gap-x-1.5 rounded-small border border-solid border-input bg-background px-2 py-[7px] text-foreground ring ring-transparent ring-offset-2 ring-offset-background drop-shadow-[0_15px_25px_rgba(0,0,0,0.02)] transition hover:bg-accent hover:text-accent-foreground focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:ring-transparent",
      onClick: () => {
        if ("buttonLink" in t) {
          e(t.buttonLink, !0);
          const d = t.buttonLink.startsWith("tel:") || t.buttonLink.startsWith("mailto:") ? "_self" : "_blank";
          window.open(t.buttonLink, d);
        } else
          o(i, t);
      },
      children: r
    },
    t.id
  );
}
export {
  p as BotButton
};
